import styled from "styled-components";

export const RowContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 3rem;
`;

export const Title = styled.h1`
	font-size: 30px;
	font-weight: 700;
	line-height: 23px;
	color: #31475a !important;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 32px;
	margin-bottom: 3rem;
`;

export const Button = styled.button`
	box-sizing: border-box;
	display: flex;
	width: 257px;
	height: 263px;
	border: 1px solid #e5e7eb;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	border-radius: 8px;
	gap: 10px;
	padding: 32px;
`;

export const ButtonTitle = styled.div`
	font-size: 20px;
	font-weight: 700;
	color: #31475a;
`;

export const ButtonText = styled.div`
	font-size: 16px;
	color: #31475a;
`;

export const IconContainer = styled.div`
	width: 64px;
	height: 64px;
	background-color: #eef2ff;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
`;
